/**
 * Les ancres d'un `<LinearGradient>` qui tient son angle CSS sur la boîte qu'il remplit.
 *
 * `expo-linear-gradient` prend deux points en fractions de la boîte, que les deux moteurs
 * multiplient par sa largeur et sa hauteur : des ancres figées ne valent l'angle voulu que sur
 * un carré. Le crochet mesure la boîte (`onLayout`, à poser sur la VUE qui porte le dégradé) et
 * recalcule les ancres par `utils/gradientAnchors`. Avant la première mesure, celles du carré.
 */
import { useState } from "react"
import { type LayoutChangeEvent } from "react-native"

import { gradientAnchors, type GradientAnchors } from "../utils/gradientAnchors"

export function useGradientAnchors(angleDeg: number): {
    anchors: GradientAnchors
    onLayout: (event: LayoutChangeEvent) => void
} {
    // La taille est un état d'INTERFACE : le composant la mesure seul, personne ne la lui donne.
    const [box, setBox] = useState({ width: 0, height: 0 })
    const onLayout = (event: LayoutChangeEvent) => {
        const { width, height } = event.nativeEvent.layout
        setBox((previous) => (previous.width === width && previous.height === height ? previous : { width, height }))
    }

    return { anchors: gradientAnchors(angleDeg, box.width, box.height), onLayout }
}
